// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__fukFA","tab-item":"Tab_tab-item__32fca","is-active":"Tab_is-active__1Hy6C"};